// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-btn[data-v-02c41cd4]{position:absolute;top:7px;right:7px;width:10px;height:10px;background-size:cover;cursor:pointer;z-index:1}@media(min-width:768px){.close-btn[data-v-02c41cd4]{width:12px;height:12px;top:10px;right:10px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
